import type { PlatformAdapter } from './types';

/**
 * Tauri-specific capabilities are isolated here.
 * The shared SPA remains fully functional when Tauri APIs are unavailable.
 *
 * Production guidance (SPX-014 / SPX-015): prefer pointing the WebView at
 * https://app.spoxhq.com so auth cookies and /api share one origin. When the
 * shell loads local dist assets, set VITE_APP_ORIGIN=https://app.spoxhq.com
 * and use the CORS allowlist — cookie session may still require same-origin
 * navigation for full fidelity.
 */
export const tauriPlatform: PlatformAdapter = {
  kind: 'tauri',
  isDesktopShell: true,
  getAppLabel() {
    return 'Spox Desktop';
  },
  getApiBaseUrl() {
    const fromEnv = (import.meta as ImportMeta & { env?: Record<string, string> }).env
      ?.VITE_APP_ORIGIN;
    return (fromEnv ?? '').replace(/\/$/, '');
  },
  async openExternal(url: string) {
    try {
      // Optional Tauri shell plugin — fall back to browser open when absent.
      const mod = await import('@tauri-apps/api/core');
      if (typeof mod.invoke === 'function') {
        await mod.invoke('plugin:shell|open', { path: url });
        return;
      }
    } catch {
      // Fall through to window.open for PWA / missing plugin cases.
    }
    window.open(url, '_blank', 'noopener,noreferrer');
  },
};
